import BaseStyle from '@primevue/core/base/style';

const classes = {
    root: 'p-steplist'
};

export default BaseStyle.extend({
    name: 'steplist',
    classes
});
